import React from 'react';
import PropTypes from 'prop-types';

require('./SecondaryButton.scss');

const SecondaryButton = ({
    onClickFunction,
    text,
    subText,
    loading,
    float
}) => {

    const handleOnClick = () => {
        onClickFunction();
    }

    return (
        <button
            onClick={handleOnClick}
            className="secondaryBtn"
            style={{ float: float }}
            disabled={loading}
        >
            <span className="btnText">{loading ? 'Loading...' : text}</span><br />
            <span className="btnSubText">({loading ? 'Loading...' : subText})</span>
        </button>
    );
};

SecondaryButton.propTypes = {
    onClickFunction: PropTypes.func.isRequired,
    text: PropTypes.string,
    loading: PropTypes.bool,
};

SecondaryButton.defaultProps = {
    text: '',
    loading: false,
    subText: '',
    float: 'none'
};

export default SecondaryButton;